import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  uploadDailyUseSentenceAsync,
  getAllDailyUseSentencesAsync,
  addDailyUseSentencesAsync,
  getDailyUseSentenceByIdAsync,
  updateDailyUseSentencesByIdAsync,
  deleteDailyUseSentenceAsync,
  deleteDailyUseSentenceMapAsync,
} from "./dailysentences.async";

const initialState = {
  sentencesLoader: false,
  sentencesBulkLoader: false,
  bulkSentences: [],
  addSentences: [],
  updateSentenceById: [],
  getSentenceById: [],
  getAllSentence: [],
  deleteLoader: false,
  deletedData: [],
  deleteSentence: [],
  deletedSentenceLoader: false,
};

export const dailySentencesSlice = createSlice({
  name: "Word Bank",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        addDailyUseSentencesAsync.pending,
        getDailyUseSentenceByIdAsync.pending,
        updateDailyUseSentencesByIdAsync.pending
      ),
      (state) => {
        state.sentencesLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteDailyUseSentenceMapAsync.pending),
      (state) => {
        state.deletedSentenceLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteDailyUseSentenceMapAsync.fulfilled),
      (state, action) => {
        state.deletedSentenceLoader = false;
        state.deleteSentence = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteDailyUseSentenceMapAsync.rejected),
      (state, action) => {
        state.deletedSentenceLoader = false;
      }
    );

    builder.addMatcher(
      isAnyOf(uploadDailyUseSentenceAsync.pending),
      (state) => {
        state.sentencesBulkLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteDailyUseSentenceAsync.pending),
      (state) => {
        state.deleteLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(uploadDailyUseSentenceAsync.fulfilled),
      (state, action) => {
        state.sentencesBulkLoader = false;
        state.bulkSentences = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(uploadDailyUseSentenceAsync.rejected),
      (state, action) => {
        state.sentencesBulkLoader = false;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllDailyUseSentencesAsync.pending),
      (state) => {
        state.sentencesLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllDailyUseSentencesAsync.fulfilled),
      (state, action) => {
        state.sentencesLoader = false;
        state.getAllSentence = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(addDailyUseSentencesAsync.fulfilled),
      (state, action) => {
        state.sentencesLoader = false;
        state.addSentences = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(getDailyUseSentenceByIdAsync.fulfilled),
      (state, action) => {
        state.sentencesLoader = false;
        state.getSentenceById = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(updateDailyUseSentencesByIdAsync.fulfilled),
      (state, action) => {
        state.sentencesLoader = false;
        state.updateSentenceById = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteDailyUseSentenceAsync.fulfilled),
      (state, action) => {
        state.deleteLoader = false;
        state.deletedData = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(deleteDailyUseSentenceAsync.rejected),
      (state, action) => {
        state.deleteLoader = false;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllDailyUseSentencesAsync.rejected),
      (state, action) => {
        state.sentencesLoader = false;
      }
    );

    builder.addMatcher(
      isAnyOf(
        addDailyUseSentencesAsync.rejected,
        getDailyUseSentenceByIdAsync.rejected,
        updateDailyUseSentencesByIdAsync.rejected
      ),
      (state, action) => {
        state.sentencesLoader = false;
      }
    );
  },
  reducers: {
    emptyDailySentence: (state) => initialState,
  },
});

export const { emptyDailySentence } = dailySentencesSlice.actions;

export default dailySentencesSlice.reducer;
